import DeptTree from './src/index';

/* istanbul ignore next */
DeptTree.install = function(Vue) {
  Vue.component(DeptTree.name, DeptTree);
};

export default DeptTree;
